import { Card } from '@mantine/core';
import classes from './TouringCardHeader.module.css';

export const TouringCardHeader: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <Card.Section className={classes.root}>{children}</Card.Section>;
};
